<main>
  <section
    style="
      background-image: url('assets/images/quote-hero.jpg');
      background-size: cover;
      background-position: center;
    "
  >
    <div class="container px-4 py-5">
      <div class="row align-items-start g-lg-5 py-5">
        <div class="col-lg-10 text-lg-start text-light">
          <h1 class="display-4 lh-1 mb-3 py-4">Get a Quote</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="container">
    <div class="row px-4 py-4 mt-5 text-center">
      <p class="display-5 mb-4">Let's get things started</p>
      <div class="col-lg-10 mx-auto">
        <p class="fs-5 mb-4">
          Please provide us your information so we can determine the appropriate
          quote for your coverage needs.
        </p>
      </div>
    </div>
  </div>

  <div class="container px-4 mb-5">
    <div class="row g-5">
      <div class="col-12">
        <div class="card p-4 fs-6">
          <form [formGroup]="quoteForm" (ngSubmit)="onSubmit()">
            <div class="row gx-5 gy-4">
              <div class="col-12">
                <label for="fullName" class="form-label">
                  Name
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  formControlName="fullName"
                  class="form-control fs-6"
                  id="fullName"
                  [ngClass]="{
                    'is-invalid':
                      quoteForm.controls['fullName'].invalid &&
                      quoteForm.controls['fullName'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    quoteForm.controls['fullName'].invalid &&
                    quoteForm.controls['fullName'].touched
                  "
                  class="invalid-feedback"
                >
                  Name is required.
                </div>
              </div>

              <div class="col-md-6">
                <label for="phoneNumber" class="form-label">
                  Phone Number
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  formControlName="phoneNumber"
                  class="form-control fs-6"
                  id="phoneNumber"
                  [ngClass]="{
                    'is-invalid':
                      quoteForm.controls['phoneNumber'].invalid &&
                      quoteForm.controls['phoneNumber'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    quoteForm.controls['phoneNumber'].invalid &&
                    quoteForm.controls['phoneNumber'].touched
                  "
                  class="invalid-feedback"
                >
                  Phone number is required.
                </div>
              </div>

              <div class="col-md-6">
                <label for="email" class="form-label">
                  Email address
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="email"
                  formControlName="email"
                  class="form-control fs-6"
                  id="email"
                  [ngClass]="{
                    'is-invalid':
                      quoteForm.controls['email'].invalid &&
                      quoteForm.controls['email'].touched,
                  }"
                  required
                />
                <div
                  *ngIf="
                    quoteForm.controls['email'].invalid &&
                    quoteForm.controls['email'].touched
                  "
                  class="invalid-feedback"
                >
                  <span
                    *ngIf="quoteForm.controls['email'].errors?.['required']"
                  >
                    Email address is required.
                  </span>
                  <span *ngIf="quoteForm.controls['email'].errors?.['email']">
                    Please enter a valid email address.
                  </span>
                </div>
              </div>

              <div class="col-md-6">
                <label for="city" class="form-label">City</label>
                <input
                  type="text"
                  formControlName="city"
                  class="form-control fs-6"
                  id="city"
                />
              </div>
              <div class="col-md-6">
                <label for="state" class="form-label">State</label>
                <select
                  formControlName="state"
                  class="form-select fs-6"
                  id="state"
                >
                  <option selected disabled value="">Select your state</option>
                  <option *ngFor="let s of states" [value]="s.abbreviation">
                    {{ s.name }}
                  </option>
                </select>
              </div>
              <div class="col-12">
                <label for="equipmentDescription" class="form-label">
                  Please provide a brief description of equipment.
                </label>
                <textarea
                  formControlName="equipmentDescription"
                  class="form-control"
                  id="equipmentDescription"
                  rows="3"
                ></textarea>
              </div>
              <div class="col-12">
                <button type="submit" class="btn btn-primary mt-2">
                  Get Quote
                </button>
              </div>
              <p *ngIf="errorMessage" class="fs-5 text-center text-danger">
                {{ errorMessage }}
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>
